module.exports = __webpack_public_path__ + "static/2_3_game-tree-4_ES-2ea539b889d2f59a2e713f626f67a02f.svg";